import AuthHelper from 'features/Auth/authHelper';
import AppRoute from 'general/constants/AppRoute';
import { useRoutePermission } from 'hooks/useRoutePermission';
import { Navigate } from 'react-router-dom';
import KTPageError01 from '../OtherKeenComponents/KTPageError01';
import { useSelector } from 'react-redux';

// Route yeu cau phai dang nhap
// Neu chua dang nhap nhay ve man hinh dang nhap '/sign-in'
function PrivateRoute(props) {
  // MARK: --- Params ---
  const isAuth = AuthHelper.checkAccessTokenValid() ?? false;
  const { user, agencyRoleList, permissionList } = useSelector((state) => state.auth);

  const { hasPermission, isPermissionReady } = useRoutePermission(user, agencyRoleList, permissionList);
  if (!isAuth) return <Navigate to={AppRoute.auth} />;

  if (_.isEmpty(user)) return null;

  if (!isPermissionReady) return null;

  return hasPermission ? props.children : <KTPageError01 />;
}

export default PrivateRoute;
